export enum Size {
  Small = "small",
  Medium = "medium",
  Large = "large",
  FullWidth = "full-width",
}
export enum StatusWorking {
  NotSet = 1,
  Working = 2,
  WorkingLate = 3,
  NotWorking = 4,
  Unknown = 5,
}

export enum ExportCsvType {
  Daily = 1,
  Date_Range = 2,
}

export enum TableSessionStatus {
  NotStart = 1,
  Starting = 2,
  End = 3,
  Stop = 4,
}

export enum TableSessionType {
  First = 1,
  Referral = 2,
  Peer = 3,
}

export enum CommonStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  NOT_VERIFY = 2,
  REJECT = 3,
}

export enum SocketUpdateTableType {
  EDIT = 1,
  ADD = 2,
  DELETE = 3,
}

export enum StepInfoStatus {
  Not_Run = 1,
  Running = 2,
  Done = 3,
}

export enum DeviceType {
  Mobile = 1,
  Tablet = 2,
  Desktop = 3,
  Large,
}

export const KeyConfig = {
  LIST_INDEX_TABLE: "LIST_INDEX_TABLE",
  ENTROPY_INPUT: "ENTROPY_INPUT",
};

export enum UserPlan {
  Lite = 1,
  Standard = 2,
  SubAccount = 3,
}
